import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqData = [
  {
    question: "What is Lovers Labs ART?",
    answer:
      "We are an AI-powered creative platform that transforms descriptions into visual artworks. Our focus is on offering artistic freedom, including creations with sensual and adult aesthetics, within legal and ethical boundaries.",
  },
  {
    question: "What makes Lovers Labs ART unique?",
    answer:
      "We are proud to be the world's leading platform for generating NSFW art, created to deliver stunning and realistic artwork powered by cutting-edge artificial intelligence. Our system produces high-quality images and short videos, up to 10 seconds long, with native audio—you can even set the voice and dialogue directly for complete immersion!\n\nFor unparalleled realism, each video can be enhanced to 4K resolution at 60 frames per second, ensuring a smooth cinematic experience that sets a new standard in AI-generated adult art.",
  },
  {
    question: "Is it allowed to generate any type of image?",
    answer:
      "No. Content involving illegal themes, minors, explicit violence, or non-consensual situations is strictly prohibited and automatically blocked.",
  },
  {
    question: "How do credits work?",
    answer:
      "Each generation consumes a certain number of credits depending on its complexity and type (image, video, or upscale). You can top up credits at any time.",
  },
  {
    question: "Do credits expire?",
    answer: "No, credits remain active as long as your account is in use.",
  },
  {
    question: "What payment options are available?",
    answer:
      "We accept Pix (available only for customers in Brazil), international credit cards, PayPal, bank transfers, and a wide range of local payment options\n\nThe process is fast, secure, and approved within seconds — so you can instantly unlock your credits and start creating right away.",
  },
  {
    question: "Are my creations private?",
    answer: "Yes. No generation is public by default. Only you have access to your creations.",
  },
  {
    question: "Are my data and payments secure?",
    answer:
      "Yes. We use certified payment providers and end-to-end encryption. No sensitive data is stored on our servers.",
  },
  {
    question: "Can I use the generated images commercially?",
    answer:
      "Yes, as long as you comply with local laws and the platform's terms of use. The user is responsible for the context in which the image is used.",
  },
];

export const GalleryFAQ = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-4">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-500 to-orange-600 mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-muted-foreground">Find answers to common questions about our platform</p>
      </div>

      <Accordion type="single" collapsible className="w-full space-y-4">
        {faqData.map((faq, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="border border-border/40 rounded-lg overflow-hidden bg-background/40 backdrop-blur-sm hover:border-amber-500/50 transition-colors"
          >
            <AccordionTrigger className="px-6 py-4 text-left hover:no-underline hover:bg-background/60 transition-colors">
              <span className="font-semibold text-foreground pr-4">{faq.question}</span>
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-4 text-muted-foreground whitespace-pre-line">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
